module.exports = __webpack_public_path__ + "img/ManОfSteel.12cf3210.png";